module.exports = __webpack_public_path__ + "img/func1.a537b70a.png";